module.exports = __webpack_public_path__ + "static/media/stp_track&field.95158f9d.jpg";